import { VueConstructor } from 'vue';
import { CoreOptions } from '../../index';
import withoutWatchers from './withoutWatchers';

declare module 'vue/types/vue' {
  interface Vue {
    $withoutWatchers: typeof withoutWatchers
  }
  interface VueConstructor {
    $withoutWatchers: typeof withoutWatchers
  }
}

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    // Only works on an instance of a component, no need to set it on Vue directly
    // Vue.$withoutWatchers = withoutWatchers;
    Vue.prototype.$withoutWatchers = withoutWatchers;
  },
};
